/**
 * Countries from /common/v1/countries that Alpha has no origin country for. The API rejects them
 * with DMS-CO-GL-0001, which would break the whole classifieds list.
 * Verified on DEV in October 2026 against every code from /common/v1/countries – keep in sync
 * with the BE conversion (CatalogueCountryConverter::toCatalogue).
 */
export const UNSUPPORTED_ORIGIN_COUNTRY_CODES: readonly string[] = [
  'ALA',
  'BES',
  'BLM',
  'CCK',
  'CIV',
  'CUW',
  'FLK',
  'GNB',
  'MAF',
  'PSE',
  'REU',
  'SHN',
  'SSD',
  'TLS',
  'TWN',
];
